import React from "react";

const ProfitLossReportFilterForm = () => {
  return <div></div>;
};

export default ProfitLossReportFilterForm;
